export default "__VITE_ASSET__NHnMycAr__"